// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1r8ib","right":"Footer_right__U7JfI","buttons":"Footer_buttons__3euPU"};